<template>
    <td>
        <el-switch v-model="data.singlecarrier.products.deja.enabled"/>
    </td>
</template>

<script>
export default {
    props: [
        'data'
    ]
}
</script>